import { Heading } from "@chakra-ui/react";

export default function Threecol(){
    return(
        <div><Heading>3 column</Heading></div>
    )
}